import { forwardRef } from "react";

function Root(props, ref) {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 3H7C5.3 3 4 4.3 4 6V6.8C4 7.6 3.9 8.3 3.6 9.1C3.3 10.2 2.2 11 1 11V13C2.2 13 3.3 13.8 3.6 14.9C3.9 15.6 4 16.4 4 17.2V18C4 19.7 5.3 21 7 21H17C18.7 21 20 19.7 20 18V17.2C20 16.4 20.1 15.7 20.4 14.9C20.8 13.8 21.8 13 23 13V11C21.8 11 20.7 10.2 20.4 9.1C20.1 8.4 20 7.6 20 6.8V6C20 4.3 18.7 3 17 3Z"
        stroke="#fff"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M9.7998 12H12.6998C13.8998 12 14.7998 12.9 14.7998 14.1C14.7998 15.3 13.8998 16.2 12.6998 16.2H9.7998V7.80005H12.6998C13.8998 7.80005 14.7998 8.70005 14.7998 9.90005C14.7998 11.1 13.8998 12 12.6998 12H9.7998Z"
        stroke="#fff"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
const BootStrap = forwardRef(Root);
export default BootStrap;
